import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickBasketBuyerInfoSection from "@/features/pathpick/features/basket/components/buyer-info/PathPickBasketBuyerInfoSection";
import { SMARTSTORE_OVERSEAS_SALES_PERMISSION_GUIDE_URL } from "@/features/pathpick/features/basket/constants";

// 스마트스토어 해외 판매 권한 신청 안내 — 판매자 기본 정보 설정 모달의 첫 섹션으로 진입 경로와 무관하게 붙는다.
//
// 권한이 없으면 주소록에 해외 출고지를 등록할 수 없어 다른 설정을 아무리 채워도 연동이 막힌다.
// 확인할 방법이 없는 조건이라 판정 없이 안내만 한다.
// (입력할 게 없는 섹션이지만 다른 설정과 같은 카드 골격을 써야 목록이 한 덩어리로 읽힌다)
function PathPickBasketOverseasSalesPermissionNotice() {
  const { t } = useI18nHelper();

  return (
    <PathPickBasketBuyerInfoSection
      icon={"clipboard-check"}
      title={t("path_pick:basket.buyer_info.overseas_permission.title")}
      description={t("path_pick:basket.buyer_info.overseas_permission.path")}
    >
      <Flex flexDirection={"column"} gap={"6px"}>
        <Text textStyle={"body-sm-medium"} color={"#444440"}>
          {t("path_pick:basket.buyer_info.overseas_permission.body")}
        </Text>
        <Text
          textStyle={"body-sm-bold"}
          color={"#1272EF"}
          width={"fit-content"}
          cursor={"pointer"}
          textDecoration={"underline"}
          whiteSpace={"nowrap"}
          onClick={() =>
            window.open(
              SMARTSTORE_OVERSEAS_SALES_PERMISSION_GUIDE_URL,
              "_blank",
              "noopener,noreferrer"
            )
          }
        >
          {t("path_pick:basket.buyer_info.overseas_permission.link")}
        </Text>
      </Flex>
    </PathPickBasketBuyerInfoSection>
  );
}

export default PathPickBasketOverseasSalesPermissionNotice;
